module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data) ? _c('div', {
    staticClass: "page-title",
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [(_vm.data.subtitle) ? _c('h2', {
    staticClass: "page-subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.data.subtitle)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.title) ? _c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.data.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.disclaimer) ? _c('span', {
    staticClass: "title-disclaimer",
    domProps: {
      "innerHTML": _vm._s(_vm.data.disclaimer)
    }
  }) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f9252a74"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/block/BlockPageTitle.vue
// module id = 726
// module chunks = 0